const affiliateTagMap = {
  // This is used mostly by default for this site, replace if seen
  DEFAULT: 'jd-default-20',

  SUB_SAVE: 'sr22-20',

  SUB_SAVE_CONTROL: 'sr22-01-20',

  SUB_SAVE_TEST: 'sr22-02-20',

  // used on the favorites page
  FAVORITES: 'jd-favorite-20',

  // Used on the blog page
  FEED: 'jd-blog-20',

  // Used for the main post on blog page
  FEED_MAIN: 'jd-bmain-20',

  FEED_MAIN_OLD: 'jdb-blog-main-20',

  // Used on the blog page
  FEED_ADDITIONAL: 'jd-blog-adtl-20',

  JD_SUBSCRIBE_SAVE_CANCEL: 'jd-ss-cancel-20',

  // Not used here, but this is for the subscribe & save deals page on JDB
  SUB_SAVE_JDB: 'jdb-ss-20',

  // This is used for the brand pages but not here
  JDB_BRAND: 'jdb-brand-20',

  // This is used for the brand pages on this site
  JD_BRAND: 'jd-brand-20',

  // This is used for the brand pages on this site
  JD_DEFAULT_PAGE_DEAL: 'jd-sh-20',

  // This is used for the brand pages on this site
  JD_GIFT_GUIDE: 'jd-gg-20',

  // This is for the pet supplies post
  JDB_PET: 'jdb-pet-20',

  // This is for the back to school post and categories without tags
  JDB_BTS: 'jdb-bts-20',

  // Daily deals post
  JDB_DAILY: 'jd-daily-20',
  JDB_DAILY_OLD: 'jdb-daily-20',
  JD_IMAGES: 'jd-deal-image-20',

  // Grocery deals post
  JDB_GROCERY: 'jdb-grocery-20',

  // Toys page
  JDB_TOYS: 'jd-toys-20',
  JDB_TOYS_OLD: 'jdb-toys-20',

  JD_TOP_DEALS: 'jd-top-deals-20',

  JD_TOP_DEALS_DAY: 'jd-top-deals-today-20',

  JD_DEAL_COUPON: 'jd-deal-coupon-20',

  // Diapers page
  JDB_DIAPERS: 'jdb-diapers-20',

  // Lego page
  JDB_LEGO: 'jdb-lego-20',

  JD_LEGO: 'jd-lego-20',

  // Barbie page
  JDB_BARBIE: 'jdb-barbie-20',

  JD_BARBIE: 'jd-barbie-20',

  // Promotions where the more you buy the more you save
  JDB_BULK_PROMO: 'jdb-buy-save-20',

  // Individual discount posts
  JDB_POST: 'xglz-wid-20',

  // Gift card deals post
  JDB_GIFT: 'jd-gift-cards-20',
  JDB_GIFT_OLD: 'jdb-gift-cards-20',

  JD_SPECIAL_OFFERS: 'jd-so-20',

  // Discounts under $3 for subscribe & save
  JDB_UNDER_3: 'jd-under-3-20',
  JDB_UNDER_3_OLD: 'jdb-under-3-20',

  // Not used much anymore but used to be default
  // Should replace occurances
  JDB_DEFAULT: 'jd-dft-20',

  JDB_DEFAULT_OLD: 'vfrifr-20',

  // not really used since coupons removed
  DEAL_TERMS: 'dealterms-20',

  // use for the individual deal pages
  HOW_TO_GET_DEAL: 'howtogetdeal-20',

  PRODUCT_PAGE: 'jd-page-20',

  DEAL_OLD: 'jdb-deal-20',

  // used on the database page
  DEAL: 'jd-deal-20',
  DATABASE: 'jd-deal-20',

  DATABASE_CONTROL: 'jd-deal-01-20',
  DATABASE_TEST: 'jd-deal-02-20',

  DIAPER_DEALS_LIST: 'jd-diapers-20',

  BEST_SELLER: 'jd-best-sell-20',

  // This is used for the variations clicks
  VARIATIONS: 'jd-xglzwckb-20',
  VARIATIONS_OLD: 'xglzwckb-20',

  // This is for the variations popup on first use to put the cookie in the
  // user's browser.
  VARIATIONS_POP_UP: 'j00000996-20',

  // These are for the list features
  LISTS: 'list-jd-20',

  // These are for the hauls
  HAUL: 'jd-haul-20',

  // popular deals rail
  MOST_POPULAR: 'jd-pop-20',

  MOST_POPULAR_COUPON: 'jd-pop-20',

  BLACK_FRIDAY_WEEK: 'jd-bf-20',

  CYBER_MONDAY_WEEK: 'jd-cm-20',

  // weekly deals lists
  WEEKLY: 'jd-weekly-20',
  WEEKLY_OLD: 'jdb-weekly-20',

  BLOCKED: 'jd-blocked-20',

  // prime day page
  PRIME_DAY: 'jd-pd-20',

  COUPON_PAGE: 'jd-coupon-20',

  COUPON_PAGE_OLD: 'jdb-coupon-20',

  BLACK_FRIDAY: 'jd-abf-20',

  CYBER_MONDAY: 'jd-acm-20',

  GIFT_GUIDE: 'jd-gg-20',

  JD_TOILET_PAPER: 'jd-tp-20',

  CATS_PAGE: 'jd-cats-20',

  DOGS_PAGE: 'jd-dogs-20',

  K_CUPS_PAGE: 'jd-k-cups-20',

  NAILS_PAGE: 'jd-nails-20',

  BEAUTY_PAGE: 'jd-beauty-20',

  HOUSEHOLD_PAGE: 'jd-household-20',

  SNACKS_PAGE: 'jd-snacks-20',

  PROMO_PAGE: 'jd-promo-20',

  GROCERY_PAGE: 'jd-grocery-20',

  PROTEIN_PAGE: 'jd-pp-20',

  LUXURY_BEAUTY_PAGE: 'jd-lux-20',

  ADVENT_CALENDAR_PAGE: 'jb-advent-20',

  LIP_BALM_PAGE: 'jd-lb-20',

  SUB_SAVE_UNDER_3_PAGE: 'jd-under-3-20',

  LAUNDRY_PAGE: 'jd-laundry-20',

  BOOKS_KIDS_PAGE: 'jd-books-kids-20',

  WET_N_WILD_PAGE: 'jd-wnw-20',

  SHAVING_PAGE: 'jd-shaving-20',

  PETS_PAGE: 'jd-pets-20',

  TEACHERS_PAGE: 'jd-teachers-20',

  MELISSA_DOUG_PAGE: 'jd-melissa-doug-20',

  BOARD_GAMES_PAGE: 'jd-board-games-20',

  COOKIES_PAGE: 'jd-cookies-20',

  MEALS_SIDES_PAGE: 'jd-meals-sides-20',

  YANKEE_CANDLE_PAGE: 'jd-yc-20',

  BATTERIES_PAGE: 'jd-batteries-20',

  ENERGY_DRINKS_PAGE: 'jd-energy-drinks-20',

  BREAKFAST_PAGE: 'jd-breakfast-20',

  SPARKLING_WATER_PAGE: 'jd-sparkling-water-20',

  RIMMEL_PAGE: 'jd-rimmel-20',

  SALLY_HANSEN_PAGE: 'jd-sally-hansen-20',

  BABY_TODDLER_TOYS_PAGE: 'jd-baby-toddler-toys-20',

  PLUSHIE_PAGE: 'jd-plushie-20',

  FIGURES_PAGE: 'jd-figures-20'
};

export default affiliateTagMap;
